import React, { useMemo } from "react";
import PropTypes from "prop-types";
import OverviewSection from "~/assets/js/pages/Checkout/sections/OrderOverview/OverviewSection";
import OrderItem from "./OrderItem";
import { filterWPAvailableProducts } from "../../Helpers/util";

const OrderItems = ({ orderItems }) => {
    const itemsAvailableInWP = useMemo(
        () =>
            filterWPAvailableProducts(
                orderItems.map((item) => item.wordpress_product_id)
            ),
        []
    );

    return (
        <OverviewSection
            title="overview.products"
            titleOptions={{ quantity: orderItems ? orderItems.length : 0 }}
        >
            {orderItems &&
                orderItems.map((product) => (
                    <OrderItem
                        isAvailable={itemsAvailableInWP.includes(
                            product.wordpress_product_id
                        )}
                        key={product.product_id}
                        orderItem={product}
                    />
                ))}
        </OverviewSection>
    );
};

OrderItems.propTypes = {
    orderItems: PropTypes.array.isRequired,
};

export default OrderItems;
